// @ts-nocheck
import Content from "./content";
import { firmStats, isFirmFromPoi } from "~/util/review";
import { _ } from "~/i18n";
import { createBookingLink } from "~/ui/booking-link";

/**
 * @class HotelCheck
 * @augments Content
 * @private
 */
export default class HotelCheck extends Content {
	_build() {
		this._dom.container.classList.add("content-hotelcheck");

		const isBooking = this._options.extend.poi.booking.url.indexOf("https://www.booking.com/") === 0;
		const bookingLink = createBookingLink({
			title: _("detail.content.booking.priceAndAvail"),
			link: this._data,
			logo: isBooking,
			onClick: () => {
				Mapy.getComponent("logger").log("clickBooking", {
					id: this._options.id,
					source: this._options.source,
					name: this._options.title,
					typeId: 2,
					placeId: 1,
					target: isBooking ? "booking" : "custom",
				});

				// pouze pro ceske veci
				if (isFirmFromPoi(this._options)) {
					firmStats("firmy-vizitka-akce", this._options, {
						placeId: 1,
						typeId: isBooking ? 28 : 29,
					});
				}
			},
		});

		this._dom.container.appendChild(bookingLink);
	}
}
